// Configurazione globale del sito ING Vasta
export const SITE_CONFIG = {
  name: "Ing. Vasta Ivan",
  fullName: "Dott. Ing. Vasta Ivan",
  tagline: "Energia Solare per il Futuro",
  phone: "+39 328 171 6021",
  phoneRaw: "393281716021",
  email: "ivanvasta@virgilio.it",
  city: "San Cataldo (CL)",
  region: "Sicilia",
  coverage: "Operiamo in tutta Italia",
  whatsappMessage: "Ciao! Vorrei informazioni sui vostri servizi fotovoltaici.",
  logoUrl: "https://customer-assets.emergentagent.com/job_energia-redeploy/artifacts/0u8idvey_rwc9f7z4_Brown%20Modern%20Minimalist%20Initial%20Logo%20%288%29.png",
  engineerPhoto: "https://customer-assets.emergentagent.com/job_energia-redeploy/artifacts/fhhq6mnb_Immagine%202026-05-20%20180927.png",
};

export const getWhatsAppLink = (customMessage) => {
  const msg = encodeURIComponent(customMessage || SITE_CONFIG.whatsappMessage);
  return `https://wa.me/${SITE_CONFIG.phoneRaw}?text=${msg}`;
};

export const getTelLink = () => `tel:${SITE_CONFIG.phone.replace(/\s/g, "")}`;

export const getMailLink = (subject) => {
  const s = subject ? `?subject=${encodeURIComponent(subject)}` : "";
  return `mailto:${SITE_CONFIG.email}${s}`;
};
